<script>
export default {
  name: 'YandexReviews',
  mounted() {
    let script = document.createElement('script');
    script.src = 'https://res.smartwidgets.ru/app.js';
    this.$refs.script.appendChild(script);
  },
};
</script>

<template>
  <section class="section section_gray section_indents">
    <div class="container">
      <div ref="script">
        <div
          class="sw-app"
          data-app="1044244ac5bb4c08bedd0c5733a9cd6a"
        ></div>
      </div>
    </div>
  </section>
</template>